import { ROUTE_PATH } from '@consts/appConsts'

/**
 * Server citation type → the detail screen of that record (see AssistantRecordTypes in the API).
 * An unknown type opens nothing, so an older client stays safe when the server learns a new one.
 */
const DETAIL_ROUTES: Record<string, (_id: string, _label: string) => any> = {
  case: ROUTE_PATH.assessment.detail,
  supplementary: ROUTE_PATH.supplementary.detail,
  file_review: ROUTE_PATH.fileReview.detail,
  medneg: ROUTE_PATH.medneg.detail,
  ndis: ROUTE_PATH.ndis.detail,
  funding_transaction: ROUTE_PATH.disbursementFunding.detail,
  facility_agreement: ROUTE_PATH.fundingAgreement.detail,
  specialist: ROUTE_PATH.specialist.detail,
  client: ROUTE_PATH.client.detail,
  company: ROUTE_PATH.company.detail,
  case_manager: ROUTE_PATH.caseManager.detail,
  contractor: ROUTE_PATH.contractor.detail,
  centre: ROUTE_PATH.centre.detail,
  medical_record: ROUTE_PATH.medicalRecord.detail,
  invoice: ROUTE_PATH.invoice.detail,
}

export const citationRoute = (type: string, id: string, label: string) =>
  DETAIL_ROUTES[type]?.(id, label) ?? null
